function moneyCents(value: string): bigint | null {
  if (!/^\d{1,10}(\.\d{1,2})?$/.test(value)) return null;
  const [whole = '0', fraction = ''] = value.split('.');
  const cents = BigInt(whole) * 100n + BigInt(fraction.padEnd(2, '0'));
  return cents <= 999999999999n ? cents : null;
}

export function sameMoneyAmount(left: string, right: string): boolean {
  const value = moneyCents(left);
  return value !== null && value === moneyCents(right);
}

/** Exact cents: an odd cent cannot be halved without an explicit override. */
export function halfVenueFee(value: string): string | null {
  const cents = moneyCents(value);
  if (cents === null || cents % 2n !== 0n) return null;
  const half = cents / 2n;
  return `${half / 100n}.${(half % 100n).toString().padStart(2, '0')}`;
}
